import { Time } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { IReviewListViewModel } from 'src/app/ViewModel/PeerReviewModel';

@Pipe({
  name: 'sessionpipe'
})
export class SessionpipePipe implements PipeTransform {

  transform(value:IReviewListViewModel): unknown {
    let session:String = 'FN/AN';
    let fromTimeObj = value.time_From.toString().split(':');
    let fromTime:Time={hours:Number(fromTimeObj[0]),minutes:Number(fromTimeObj[1])};
    let toTimeObj = value.time_To.toString().split(':');
    let toTime:Time={hours:Number(toTimeObj[0]),minutes:Number(toTimeObj[1])};

    if(fromTime.hours >13)
    {
      session = 'AN';
    }
    else if(toTime.hours <=13)
    {
      session = 'FN'
    }

    return session;
  }

}
